module.exports = __webpack_public_path__ + "7dd13d6554d026f6c2914c08dec109bb.svg";